import { Box, BoxProps } from "@chakra-ui/react";
import { BiRecycle } from "react-icons/bi";

export const RecycleIcon = (props: BoxProps) => {
  return <Box as={BiRecycle} height="20px" width="20px" {...props} />;
};
